import { getList } from '@/api/enroll/chongmingStudent'
import { Config, Column } from '@/components/table'
import { ChongmingStudent } from '@/models/enroll/chongmingStudent'
import { createDateFormatter } from '@/utils/formatter/date'
import { createDownloadHanlder } from './createDownloadHanlder'

const SHEET = '上海师范大学崇明地区入学申请统计表'
const COLUMNS: Column<ChongmingStudent>[] = [
  { prop: 'studentId', label: '学生ID', hidden: true },
  { prop: 'name', label: '姓名', fixed: 'left' },
  {
    prop: 'createTime',
    label: '创建时间',
    width: 160,
    format: createDateFormatter('yyyy-MM-dd hh:mm:ss')
  },
  {
    prop: 'sex',
    label: '性别',
    format: a => (Number.parseInt(a) === 0 ? '男' : '女')
  },
  { prop: 'collegeExaminationNumber', label: '高考报名号', width: 200 },
  { prop: 'idNumber', label: '身份证', width: 200 },
  { prop: 'photoUrl', label: '照片', hidden: true },
  { prop: 'birthYear', label: '出生年份', width: 80 },
  { prop: 'birthMonth', label: '出生月份', width: 80 },
  { prop: 'politicalLandscape', label: '政治面貌', width: 100 },
  { prop: 'national', label: '民族', width: 80 },
  { prop: 'contactTelephone', label: '联系电话', width: 200 },
  { prop: 'graduationSchoolName', label: '毕业学校', width: 200 },
  { prop: 'sendAddress', label: '邮寄地址', width: 350 },
  { prop: 'zipCode', label: '邮政编码', width: 80 },
  {
    prop: 'isFreshGraduation',
    label: '应届生',
    format: a => (Number.parseInt(a) === 0 ? '否' : '是')
  },
  { prop: 'homeTelephone', label: '家庭电话', width: 150 },
  { prop: 'emergencyTelephone', label: '紧急联系方式', width: 150 },
  { prop: 'homeCallName1', label: '家庭成员1称谓', width: 120 },
  { prop: 'homeRealName1', label: '家庭成员1姓名', width: 120 },
  { prop: 'homeWorkCompany1', label: '家庭成员1工作单位', width: 200 },
  { prop: 'homeCallName2', label: '家庭成员2称谓', width: 120 },
  { prop: 'homeRealName2', label: '家庭成员2姓名', width: 120 },
  { prop: 'homeWorkCompany2', label: '家庭成员2工作单位', width: 200 },
  { prop: 'homeCallName3', label: '家庭成员3称谓', width: 120 },
  { prop: 'homeRealName3', label: '家庭成员3姓名', width: 120 },
  { prop: 'homeWorkCompany3', label: '家庭成员3工作单位', width: 200 },
  { prop: 'remark', label: '备注', width: 1000 },
  {
    prop: 'lifeDetailAndAward',
    label: '个人履历及获奖情况',
    width: 1000,
    hidden: true
  }
]

export const createConfig = (): Config<ChongmingStudent> => ({
  key: 'studentId',
  columns: COLUMNS,
  data: getList,
  params: {
    sort: 'CreateTime',
    order: 'desc'
  }
})

export const downloadExcel = createDownloadHanlder(SHEET, COLUMNS, getList)
